<template>
  <div>
    <h4 class="mb-5 text-center">Select Integration</h4>
    <div class="list-group">
      <router-link v-for="(integration, key) in AVAILABLE_INTEGRATIONS"
                   :key="key"
                   :to="{query: createQueryParams(integration.type)}"
                   :event="(integration.disabled ? '' : 'click')"
                   :class="{disabled: integration.disabled}"
                   class="list-group-item list-group-item-action p-4">
        <wizard-item :icon="integration.icon"
                     :subtitle="integration.category"
                     :title="integration.type | integrationType"
                     :description="integration.description"></wizard-item>
      </router-link>
    </div>
  </div>
</template>

<script>
  import WizardItem from '@/components/administration/common/WizardItem'
  import { AVAILABLE_INTEGRATIONS } from '@/utils/integration.constants'
  import merge from 'ramda/src/merge'

  export default {
    components: {
      WizardItem
    },

    methods: {
      createQueryParams(integrationType) {
        return merge(this.$route.query, {integrationType})
      }
    },

    data() {
      return {
        AVAILABLE_INTEGRATIONS
      }
    }
  }
</script>
